import { BehaviorSubject } from "rxjs";
import { MessagesEnum } from "./enums/messages.enum";
import * as i0 from "@angular/core";
var IframeMessagesService = /** @class */ (function () {
    function IframeMessagesService() {
        this.sendMessage$ = new BehaviorSubject({ send: 0 });
        this.getMessage$ = new BehaviorSubject({ send: 0 });
        this.listenIframeMessageFunction = this.handleListenIframeMessageFunction.bind(this);
    }
    IframeMessagesService.prototype.listenIframeMessage = function () {
        this.getMessage$ = new BehaviorSubject({ send: 0 });
        window.addEventListener('message', this.listenIframeMessageFunction, false);
    };
    IframeMessagesService.prototype.unlistenIframeMessage = function () {
        window.removeEventListener('message', this.listenIframeMessageFunction, false);
        this.getMessage$.complete();
    };
    IframeMessagesService.prototype.handleListenIframeMessageFunction = function (event) {
        //console.log(event)
        if (event && event.data) {
            if (this.getMessage$) {
                this.getMessage$.next({
                    send: Math.random(),
                    data: event.data
                });
            }
        }
    };
    IframeMessagesService.prototype.closeFrame = function () {
        this.sendMessage({
            event: MessagesEnum.closeFrame
        });
    };
    IframeMessagesService.prototype.sendMessage = function (message) {
        if (message === void 0) { message = {}; }
        parent.postMessage(message, "*");
    };
    IframeMessagesService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function IframeMessagesService_Factory() { return new IframeMessagesService(); }, token: IframeMessagesService, providedIn: "root" });
    return IframeMessagesService;
}());
export { IframeMessagesService };
